import { createContext, useCallback, useContext, useMemo, useState } from "react";

const DeprecationNoticeContext = createContext(null);

// Held in memory rather than storage: dismissing the banner keeps it dismissed
// while the user moves between pages, and it opens again on a refresh or in a
// new tab, so it is seen several times over the week without nagging.
export const DeprecationNoticeProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  const collapse = useCallback(() => setCollapsed(true), []);
  const expand = useCallback(() => setCollapsed(false), []);

  const value = useMemo(
    () => ({ collapsed, collapse, expand }),
    [collapsed, collapse, expand],
  );

  return (
    <DeprecationNoticeContext.Provider value={value}>
      {children}
    </DeprecationNoticeContext.Provider>
  );
};

export const useDeprecationNotice = () => useContext(DeprecationNoticeContext);
